import { useSystemStore } from "@/stores/system/SystemStore";
import { ErrorLocationType } from "@/utilities/system/enums/Enums";

export default function hideError ({next}:any){
    const systemStore = useSystemStore();

    if (systemStore.error.location !== ErrorLocationType.none) systemStore.error.location = ErrorLocationType.none;

    return next();
}
